import React, { useState, useEffect } from "react"
import styled from "styled-components"
import { BGWrapper } from "./UIStyle/UIstyle"
import PositionAndWidth from "./PositionAndWidth"
import Decoration from "./Decoration"

export default function Popup({ showPopup, setShowPopup, content }) {
  const [counter, setCounter] = useState(0)

  useEffect(() => {
    if (counter < 100) {
      setTimeout(() => {
        setCounter(pre => pre + 1)
      }, 1000 / 120)
    }
  }, [counter])

  useEffect(() => {
    if (showPopup === "close" || showPopup === "loading") {
      setCounter(0)
    }
  }, [showPopup])

  useEffect(() => {
    if (showPopup !== "close") {
      document.body.style.overflow = "hidden"
      return
    }
    document.body.style.overflow = "auto"
  }, [showPopup])

  return (
    <BG className={showPopup}>
      <ShadowBG
        onClick={() => {
          setShowPopup("close")
        }}
      />
      <BGOutWrapper className={showPopup}>
        <PositionAndWidth
          d={{ width: "10%", t: "15%", l: "48%" }}
          m={{ width: "0", t: "8%", l: "48%" }}
        >
          <Decoration type="blobman1" animation="updown" time={12} delay={6} />
        </PositionAndWidth>
      </BGOutWrapper>
      <Wrapper className="Wrapper">
        <BGWrapper>
          <PositionAndWidth
            d={{ width: "clamp(30px,15%,120px)", t: "30%", r: "-5%" }}
            m={{ width: "clamp(30px,15%,120px)", t: "30%", r: "-5%" }}
          >
            <Decoration type="circle" animation="updown" time={12} delay={3} />
          </PositionAndWidth>
          <PositionAndWidth
            d={{ width: "0", b: "-5%", l: "-5%" }}
            m={{ width: "clamp(30px,40%,120px)", b: "-5%", r: "-5%" }}
          >
            <Decoration type="blobman1" animation="updown" time={8} delay={6} />
          </PositionAndWidth>
          <PositionAndWidth
            d={{ width: "clamp(30px,40%,120px)", b: "-5%", l: "-5%" }}
            m={{ width: "clamp(30px,40%,120px)", b: "-5%", l: "-5%" }}
          >
            <Decoration
              type="blobman2"
              animation="updown"
              time={12}
              delay={6}
            />
          </PositionAndWidth>
          <PositionAndWidth
            d={{ width: "clamp(30px,10%,120px)", b: "30%", l: "-50%" }}
            m={{ width: "clamp(30px,10%,120px)", b: "30%", l: "-50%" }}
          >
            <Decoration type="Scircle" animation="updown" time={12} delay={8} />
          </PositionAndWidth>
          <PositionAndWidth
            d={{ width: "clamp(10px,4%,120px)", b: "20%", r: "-30%" }}
            m={{ width: "clamp(10px,4%,120px)", b: "20%", r: "-30%" }}
          >
            <Decoration type="Scircle" animation="updown" time={12} delay={4} />
          </PositionAndWidth>
        </BGWrapper>

        <CancelBtnWrapper>
          <CancelBtn
            onClick={() => {
              setShowPopup("close")
            }}
          />
        </CancelBtnWrapper>
        <ContentWrapper className={showPopup}>{content}</ContentWrapper>
      </Wrapper>
      <LoadingWrapper
        className={
          showPopup === "result" ? "LoadingWrapper clear" : "LoadingWrapper"
        }
      >
        <Loading className="Loading">
          <div></div>
          <div></div>
        </Loading>
        <Number className="Number">{counter}%</Number>
      </LoadingWrapper>
    </BG>
  )
}

const BG = styled.div`
  position: fixed;
  background-color: #0000004d;
  z-index: 3000000;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: opacity 0.3s;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  will-change: transform, width;
  &.open {
    width: 100%;
    height: 100%;
  }

  &.close {
    width: 0%;
    height: 100%;
    opacity: 0;
    overflow: hidden;
    transition:
      opacity 0.3s,
      width 0.2s;
    .Wrapper {
      width: 0px;
      min-height: 0;
      overflow: hidde0n;
      padding: 0;
      opacity: 0;
      border: 1px solid #fff;
    }
  }
  &.send {
    width: 100%;
    height: 100%;
    background-color: #000000c2;
    .Wrapper {
      animation: sendNFT 2s forwards;
    }
    @keyframes sendNFT {
      40% {
        width: 0px;
        min-height: auto;
        height: auto;
        overflow: hidden;
        padding: 0;
        transform: translate(0, 0);
        background-color: #ffffff;
        border: 1px solid #fff;
      }
      50% {
        width: 0px;
        min-height: auto;
        height: auto;
        overflow: hidden;
        padding: 0;
        transform: translate(0, -100vh);
        border: 1px solid #fff;
      }
      100% {
        width: 0px;
        min-height: auto;
        height: auto;
        overflow: hidden;
        padding: 0;
        transform: translate(0, -100vh);
        border: 1px solid #fff;
      }
    }

    p,
    h3 {
      animation: color 1s forwards;
    }
    @keyframes color {
      40% {
        color: #ffffff;
      }
      80% {
        color: #ffffff;
      }
      100% {
        color: #fff;
      }
    }
  }
  &.loading {
    width: 100%;
    height: 100%;
    background-color: #000000c2;
    .Wrapper {
      width: 0px;
      min-height: auto;
      height: auto;
      overflow: hidden;
      padding: 0;
      transform: translate(0, -100vh);
      border: 1px solid #fff;
    }
    .LoadingWrapper {
      opacity: 1;
    }
  }
  &.result {
    width: 100%;
    height: 100%;
    .Wrapper {
      animation: resultNFT 3s forwards;
      @keyframes resultNFT {
        0% {
          width: 0px;
          min-height: auto;
          height: auto;
          overflow: hidden;
          border: 1px solid #fff;
          padding: 0;
          transform: translate(0, -100vh);
        }
        70% {
          width: 0px;
          min-height: auto;
          height: auto;
          overflow: hidden;
          border: 1px solid #fff;
          padding: 0;
          transform: translate(0, 0);
        }
      }
    }
  }
`

const ShadowBG = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 3;
`

const BGOutWrapper = styled(BGWrapper)`
  transition: all 0.3s;
  &.open {
    opacity: 1;
  }
  &.send {
    opacity: 0;
  }
  &.loading {
    opacity: 0;
  }
  &.result {
    transition: all 3s;
    opacity: 1;
  }
`
const Wrapper = styled.div`
  position: relative;
  width: clamp(300px, 100%, 350px);
  min-height: 200px;
  margin: 0 20px;
  /* min-width: 200px; */
  display: flex;
  border-radius: 8px;
  background-color: rgb(255, 255, 255);
  backdrop-filter: blur(100px);
  flex-direction: column;
  justify-content: start;
  align-items: center;
  padding: 60px 0 40px 0;
  transition: 0.3s;
  /* overflow: hidden; */
  z-index: 5;
  box-shadow: 0 0 30px #0000003e;
`

const ContentWrapper = styled.div`
  opacity: 0;
  transition: all 1s;
  &.open {
    opacity: 1;
  }
  &.loading {
    opacity: 0;
  }
  &.result {
    opacity: 1;
  }
`
const CancelBtnWrapper = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
  /* background-color: #88888855; */
`

const CancelBtn = styled.div`
  position: relative;
  width: 24px;
  height: 24px;
  &::before,
  &::after {
    content: "";
    width: 16px;
    height: 2px;
    background-color: #000000;
    position: absolute;
    transform: translate(-50%, -50%);
    top: 50%;
    left: 50%;
    transform: rotate(45deg);
  }
  &::after {
    transform: rotate(135deg);
  }
`

const LoadingWrapper = styled.div`
  opacity: 0;
  transition: all 0.5s;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  &.clear {
    .Loading {
      div {
        animation: lds-ripple-clear forwards 0.5s;
      }
    }
    .Number {
      opacity: 0;
    }
  }
`
const Loading = styled.div`
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;

  div {
    position: absolute;
    border: 4px solid #ffffff;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 1;
    border-radius: 50%;
    animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
  }
  div:nth-child(2) {
    animation-delay: -0.5s;
  }
  @keyframes lds-ripple {
    0% {
      width: 100px;
      height: 100px;
      opacity: 0;
    }

    5% {
      width: 100px;
      height: 100px;
      opacity: 1;
    }
    100% {
      width: 300px;
      height: 300px;
      opacity: 0;
    }
  }
  @keyframes lds-ripple-clear {
    0% {
      width: 300px;
      height: 300px;
      opacity: 0;
    }

    5% {
      width: 300px;
      height: 300px;
      opacity: 1;
    }
    100% {
      width: 1000px;
      height: 1000px;
      opacity: 0;
    }
  }
`

const Number = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #ffffff;
  transition: all 0.2s;
`
